module.exports = __webpack_public_path__ + "static/media/PCN-2024-8-20-01-LG03.b96d68f8.pdf";